var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_686:26236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 3C8.37985 3 3 8.37985 3 15C3 21.6202 8.37985 27 15 27C21.6202 27 27 21.6202 27 15C27 8.37985 21.6202 3 15 3ZM20.3643 12.2558C20.3643 12.3798 20.3643 12.4884 20.3643 12.6124C20.3643 16.2558 17.5891 20.4729 12.5039 20.4729C10.938 20.4729 9.49612 20.0233 8.27132 19.2326C8.48837 19.2636 8.70543 19.2791 8.92248 19.2791C10.2248 19.2791 11.4031 18.845 12.3488 18.1008C11.155 18.0698 10.1318 17.2636 9.77519 16.1783C9.94574 16.2093 10.1163 16.2248 10.2868 16.2248C10.5349 16.2248 10.7829 16.1938 11.0155 16.1318C9.75969 15.8837 8.79845 14.7674 8.79845 13.4186C8.79845 13.4031 8.79845 13.3876 8.79845 13.3876C9.17054 13.5891 9.58915 13.7132 10.0543 13.7287C9.31008 13.2326 8.82946 12.3953 8.82946 11.4341C8.82946 10.9225 8.96899 10.4574 9.20155 10.0388C10.5659 11.7132 12.6124 12.814 14.907 12.9225C14.8605 12.7209 14.8295 12.5039 14.8295 12.2868C14.8295 10.7674 16.0698 9.52713 17.5891 9.52713C18.3798 9.52713 19.1085 9.86822 19.6047 10.3953C20.2403 10.2713 20.8295 10.0388 21.3566 9.72868C21.155 10.3798 20.7054 10.9225 20.1473 11.2636C20.7054 11.2016 21.2481 11.0465 21.7287 10.8295C21.3721 11.3876 20.8915 11.8682 20.3643 12.2558Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_686:26236",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.760784 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_686:26236"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_686:26236",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/Twitter.bf9580d55c1b771fe4d8b3a485d5bac4.svg";
export { ForwardRef as ReactComponent };